import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Model from './Model';
import Color from './Color';
import Angle from './Angle';
import Tabs from '../../../../components/common/Tabs';
import Placement from './Placement';

const FrontBikeArt = ({
  options,
  allCategoryCustomizations,
  updatePartsConfig,
  currentActiveParent,
  setCurrentText,
  setIsConfigSaved,
  selectedTab,
  allBikeArtData,
  selectedPart,
  currentText,
  partsConfig,
  setFrontBikeNumberPlate,
  setBackBikeNumberPlate,
  tShirtBikeFrontNumberPlate,
  tShirtBikeBackNumberPlate,
  setFrontBikeText,
  setBackBikeText,
  tShirtBikeFrontText,
  tShirtBikeBackText
}) => {
  const viewCode = currentActiveParent === 'front' ? 'F' : 'B';

  const selectedAngle =
    allBikeArtData.filter(
      cust =>
        cust.customizationType === 'angle' &&
        cust.partId[cust.partId.length - 1] === viewCode &&
        partsConfig.bikeArt[cust.partId] === true
    )[0] ||
    allBikeArtData.filter(
      cust =>
        cust.customizationType === 'angle' &&
        cust.partId[cust.partId.length - 1] === viewCode
    )[0];

  return (
    <div className="front-bike-art">
      {selectedTab === 'model' && (
        <Model
          selectedAngle={selectedAngle}
          currentActiveParent={currentActiveParent}
          options={options.filter(
            entry =>
              !entry.partId.match(/BN\d{4}[F|B]/i) &&
              !entry.partId.match(/TXT\d{3}F/i)
          )}
          allBikeArtData={allBikeArtData}
          selectedPart={selectedPart}
          updatePartsConfig={updatePartsConfig}
          partsConfig={partsConfig}
          allCategoryCustomizations={allCategoryCustomizations}
        />
      )}
      {selectedTab === 'color' && (
        <Color
          selectedAngle={selectedAngle}
          currentActiveParent={currentActiveParent}
          options={options.filter(
            entry =>
              !entry.partId.match(/BN\d{4}[F|B]/i) &&
              !entry.partId.match(/TXT\d{3}F/i)
          )}
          allBikeArtData={allBikeArtData}
          selectedPart={selectedPart}
          updatePartsConfig={updatePartsConfig}
          partsConfig={partsConfig}
          allCategoryCustomizations={allCategoryCustomizations}
        />
      )}
      {selectedTab === 'angle' && (
        <Angle
          options={options}
          allBikeArtData={allBikeArtData}
          selectedAngle={selectedAngle.partId}
          updatePartsConfig={updatePartsConfig}
          partsConfig={partsConfig}
          setCurrentText={setCurrentText}
          setIsConfigSaved={setIsConfigSaved}
          currentText={currentText}
          tShirtBikeFrontNumberPlate={tShirtBikeFrontNumberPlate}
          tShirtBikeBackNumberPlate={tShirtBikeBackNumberPlate}
          tShirtBikeFrontText={tShirtBikeFrontText}
          tShirtBikeBackText={tShirtBikeBackText}
          currentActiveParent={currentActiveParent}
          setFrontBikeNumberPlate={setFrontBikeNumberPlate}
          setBackBikeNumberPlate={setBackBikeNumberPlate}
          setFrontBikeText={setFrontBikeText}
          setBackBikeText={setBackBikeText}
          allCategoryCustomizations={allCategoryCustomizations}
        />
      )}
      {currentActiveParent === 'back' && selectedTab === 'placement' && (
        <Placement
          options={options.filter(
            entry =>
              !entry.partId.match(/BN\d{4}[F|B]/i) &&
              !entry.partId.match(/TXT\d{3}F/i)
          )}
          allBikeArtData={allBikeArtData}
          selectedAngle={selectedAngle}
          tShirtBikeBackText={tShirtBikeBackText}
          selectedPart={selectedPart}
          updatePartsConfig={updatePartsConfig}
          partsConfig={partsConfig}
          setCurrentText={setCurrentText}
          setIsConfigSaved={setIsConfigSaved}
          currentText={currentText}
          allCategoryCustomizations={allCategoryCustomizations}
        />
      )}
    </div>
  );
};

FrontBikeArt.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object
};

export default FrontBikeArt;
